import React from 'react';

export default function PerformanceExecutive({
  sectionsConfig = [],
  PdfFees,
  generateTableFee,
  getValueByKey,
  divisionData,
}) {
  const sectionTitle =
    sectionsConfig.find((section) => section.key === 'performance_expectations')
      ?.title || 'Performance Expectations';

  return (
    <>
      <div className="fund-wrap-web m-2 mt-2 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content">
            <PdfFees
              carried_interest={getValueByKey('carried_interest')}
              generateTableFee={generateTableFee(divisionData?.fundFees)}
              size={getValueByKey('fund_size')}
              investment_pacing={getValueByKey('investment_pacing')}
              fund_raise_period={getValueByKey('fund_raise_period')}
              investment_period={getValueByKey('investment_period')}
              investment_term={`${getValueByKey('fund_duration')} - ${getValueByKey('extension')}`}
              net_irr={getValueByKey('net_irr')}
              expected_net_returns_in_moic={getValueByKey(
                'expected_net_returns_in_moic'
              )}
              net_roi={getValueByKey('net_roi')}
              getValueByKey={getValueByKey}
            />
          </div>
        </div>
      </div>
    </>
  );
}
